/**
 * Created by Simon Zhao on 9/8/2022.
 * Description:
 * Serves as a bridge between the note deposit trigger filter dialog and its users.
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NoteTriggerFilterDialogOptions, NoteTriggerFilterDialogResult } from './note-deposit-trigger-filter-dialog.model';

@Injectable()
export class NoteDepositTiggerFilterDialogService {

    dialogClose$: Subject<NoteTriggerFilterDialogResult> = new Subject<NoteTriggerFilterDialogResult>();
    dialogOpen$: Subject<NoteTriggerFilterDialogOptions> = new Subject<NoteTriggerFilterDialogOptions>();
}
